/**
 * MIRA Checkbox Component
 * Wraps Shadcn Checkbox with MIRA design system styles
 */

import React from 'react';
import { Checkbox as ShadcnCheckbox } from '@/components/ui/checkbox';
import { cn } from '@/lib/utils';
import styles from '@/styles/components/checkbox.module.css';

export const Checkbox = React.forwardRef(
  ({
    className,
    // Filter out custom props that shouldn't reach the DOM
    isError,
    ...props
  }, ref) => {
    return (
      <ShadcnCheckbox
        ref={ref}
        className={cn(
          styles.miraCheckbox,
          isError && styles.error,
          className
        )}
        {...props}
      />
    );
  }
);

Checkbox.displayName = 'MiraCheckbox';
